import api from './api';

/**
 * Serviço para buscar estatísticas do dashboard
 */
const dashboardService = {
  /**
   * Busca estatísticas consolidadas do dashboard
   * @returns {Promise<Object>} Estatísticas (professionals, services, places, agendas, appointments)
   */
  async getStats() {
    const response = await api.get('/dashboard/stats');
    return response.data;
  },
};

export default dashboardService;
